import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExposure1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconExposure1"><Path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12.75 6V8.75H15.5V10.25H12.75V13H11.25V10.25H8.5V8.75H11.25V6H12.75ZM8.5 15.5V17H15.5V15.5H8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconExposure1;
